import { type NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const redirectToHomeIfNoDataAccess: NavigationGuard = async () => {
  const authStore = useAuthStore();

  if (authStore.appAccess.nav.data) {
    return true;
  } else {
    return { name: 'home' };
  }
};
